<template>
  <div>
    <div class="white-card">
      <div class="white-card-header pr-40">
        <div class="title-wrap">
          <label class="title-label">{{ label.get('break_preferences_break_types') }}</label>
        </div>
        <button class="add-new-btn"
                v-if="advancedBreakTypes"
                @click="addAdvancedBreakType">
          <i class="atto atto-add-more"></i>
          {{ label.get('add_break_type') }}
        </button>
      </div>
      <div class="list-container" v-if="advancedBreakTypes">
        <div class="table-heading">
          <span class="heading-label name">{{ label.get('name') }}</span>
          <span class="heading-label break-time">{{ label.get('break_time') }}</span>
          <span class="heading-label frequency">{{ label.get('frequency') }}</span>
          <span class="heading-label type">{{ label.get('type') }}</span>
        </div>
        <ul>
          <li  v-for="(item, idx) in advancedBreakTypes"
               :key="idx"
          >
            <i class="atto atto-break setting-icon" />
            <span class="name">{{ item.name }}</span>
            <span class="break_time">{{ item.break_time }}</span>
            <span class="frequency">{{item.frequency == 1 ? 'Custom':'Once Daily'}}</span>
            <span class="type">{{ getTypeLabel(item.type) }}</span>
            <div class="options">
              <button
                  class="edit-job edit-btn"
                  @click="editAdvancedBreakType(item)"
              >
                <i class="atto atto-edit-btn" />
              </button>
              <button
                  class="delete-job delete-btn"
                  @click="deleteAdvancedBreakType(item)"
              >
                <i class="atto atto-delete" />
              </button>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="advancedBreakTypes.length === 0">
        <div class="no-items no-break-types">
          <div class="item-wrap">
            <i class="no-break-types-icon" />
            <button
                class="atto-btn add-entry add-item"
                @click="addAdvancedBreakType"
            >
              {{label.get('add_break_types')}}
            </button>
            <p>
              {{label.get('add_break_types_desc')}}
            </p>
          </div>
        </div>
      </div>
    </div>

    <add-advanced-break-type-component
        v-if="addNewAdvancedBreakType"
        :advanced-break-type="advancedBreakItem"
    />
    <edit-advanced-break-type-component
        v-if="showEditAdvancedBreakType"
        :advanced-break-type="advancedBreakItem"
    />
    <delete-advanced-break-type-component
        v-if="showDeleteAdvancedBreakType"
        :advanced-break-type="advancedBreakItem"
    />
  </div>
</template>

<script>
import BreakPreferencesService from "../services/BreakPreferencesService";
import AddAdvancedBreakTypeComponent from "./AddAdvancedBreakTypeComponent";
import DeleteAdvancedBreakTypeComponent from "./DeleteAdvancedBreakTypeComponent";
import EditAdvancedBreakTypeComponent from "./EditAdvancedBreakTypeComponent";
export default {
  name: "AdvancedBreakTypeComponent",
  components: {EditAdvancedBreakTypeComponent, DeleteAdvancedBreakTypeComponent, AddAdvancedBreakTypeComponent },
  data() {
    return {
      advancedBreakTypes: [],
      advancedBreakItem: null,
      breakRule: this.$store.state.companySettings.break_rule,
      addNewAdvancedBreakType: false,
      showEditAdvancedBreakType: false,
      showDeleteAdvancedBreakType: false
    }
  },
  created() {
    this.getAdvancedBreakTypes();
  },
  mounted() {
    this.$root.$on('hideAddAdvancedBreakType', this.hideAddAdvancedBreakType);
    this.$root.$on('hideEditAdvancedBreakType', this.hideEditAdvancedBreakType);
    this.$root.$on('hideDeleteAdvancedBreakType', this.hideDeleteAdvancedBreakType);
  },
  beforeDestroy() {
    this.$root.$off('hideAddAdvancedBreakType');
    this.$root.$off('hideEditAdvancedBreakType');
    this.$root.$off('hideDeleteAdvancedBreakType');
  },
  methods: {
    getAdvancedBreakTypes() {
      const _this = this;
      this.$store.commit('showLoading');
      BreakPreferencesService.getAdvancedBreakTypes().then((response) => {
        _this.advancedBreakTypes = response;
        this.$store.commit('hideLoading');
      }).catch((error) => {
        this.$store.commit('hideLoading');
      })
    },
    getTypeLabel(type) {
      const typeObj = this.getBreakTypes().find(x => x.value === type);
      if(typeObj) {
        return typeObj.label;
      }
      return 'Unknown';
    },
    getBreakTypes(){
      return BreakPreferencesService.getBreakTypes(this.label);
    },
    addAdvancedBreakType() {
      this.addNewAdvancedBreakType = true;
    },
    hideAddAdvancedBreakType(item){
      if(item) {
        this.advancedBreakTypes.push(item);
        this.$store.state.advancedBreakTypes = this.advancedBreakTypes;
      }
      this.addNewAdvancedBreakType = false;
    },
    editAdvancedBreakType(advancedBreakType) {
      this.advancedBreakItem = advancedBreakType;
      this.showEditAdvancedBreakType = true;
    },
    hideEditAdvancedBreakType(advancedBreakType) {
      if(advancedBreakType){
        const index = this.advancedBreakTypes.findIndex(x => x.id === advancedBreakType.id);
        if (index >= 0){
          this.advancedBreakTypes[index]= advancedBreakType;
        }
      }
      
      this.showEditAdvancedBreakType = false;
    },
    deleteAdvancedBreakType(advancedBreakType) {
      this.advancedBreakItem = advancedBreakType;
      this.showDeleteAdvancedBreakType = true;
    },
    hideDeleteAdvancedBreakType(advancedBreakType) {
      if(advancedBreakType) {
        const index = this.advancedBreakTypes.indexOf(advancedBreakType);
        this.advancedBreakTypes.splice(index, 1);
      }
      this.showDeleteAdvancedBreakType = false;
      this.advancedBreakItem = null;
    },
  }
}
</script>

<style lang="scss" scoped>
.list-container{
  .table-heading{
    border-top: none !important;
    padding: 12px 8px 12px 20px !important;

    .heading-label{
      width: 20%;
      &.name{
        margin-left: 44px;
      }
    }
  }
  ul{
    li{
      height: 50px;
      display: flex;
      align-items: center;
      padding: 13px 8px 13px 20px;
      border-top: 1px solid $atto-light-grey;

      i.atto-break{
        width: 24px;
        height: 24px;
        font-size: 19px;
        color: $atto-dark-grey;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
      }
      span{
        font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
        color: $atto-font-color;
        width: 20%;
      }

      .options {
        display: inline-flex;
        align-items: center;
        flex-direction: row;
        opacity: 1;
        margin-left: auto;
        @include base-transition(ease all 0.2s);

        .edit-btn,
        .delete-btn,
        .edit-member,
        .delete-member {
          display: flex;
          width: 40px;
          height: 40px;
          align-items: center;
          justify-content: center;
          text-align: center;
          background-color: transparent;
          border: 0;
          padding: 0;
          position: relative;

          i {
            position: absolute;
            display: inline-flex;
            width: 40px;
            height: 40px;
            font-size: 18px;
            text-align: center;
            align-items: center;
            justify-content: center;
            color: $atto-dark-grey;
            border-radius: 100%;
            @include base-transition(ease all 0.15s);

            &:before {
              @include base-transition(ease all 0.15s);
            }
          }

          &:hover:not(:disabled) {
            cursor: pointer;

            i {
              background-color: $atto-light-grey;

              &::before {
                color: $atto-font-color;
              }
            }
          }


          &:disabled {
            cursor: not-allowed;
          }
        }
      }
      &:hover{
        @include base-transition(ease all 0.2s);
        background-color: $atto-grey;
      }
    }
  }
}
.no-break-types{
  .no-break-types-icon{
    width: 88px !important;
    height: 94px !important;
    background: url('~@assets/images/no_break_type.svg') no-repeat center;
  }
  p{
    padding: 0 15px;
  }
}

</style>